import * as React from 'react';

export type AnyAction = {
  [key: string]: any;
};

export type DangerousHooks = {
  useUnsafeActionCreators: () => any;
  getActiveWindow: () => any;
  getNativeNode: () => HTMLElement | null;
};

const hooksNotSet = () => {
  throw new Error('DangerousHooks was not provided through context!');
};

// @ts-expect-error - TS2322 - Type 'Context<{ useDispatch: () => never; useDesignerSelector: () => never; useUnsafeActionCreators: () => never; getActiveWindow: () => never; getNativeNode: () => never; useFluxContext: () => never; }>' is not assignable to type 'Context<DangerousHooks>'.
export const DangerousHooksContext: React.Context<DangerousHooks> =
  React.createContext({
    useUnsafeActionCreators: hooksNotSet,
    getActiveWindow: hooksNotSet,
    getNativeNode: hooksNotSet,
  });

export const useDangerousHooks = () => React.useContext(DangerousHooksContext);
